// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveInstitutionCreditTypeMinuteHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import InstitutionCreditTypeMinuteDTO from '../models/InstitutionCreditTypeMinuteDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    creditMinutes: InstitutionCreditTypeMinuteDTO[] | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            creditMinutes: [],
        },
        initValues);
    },
    creditMinutes: 'creditMinutes',
}

interface Result extends ResultDTO {
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
        },
        initValues);
    },
}

export { Request, Result };